import React from 'react'
import { useContext } from 'react';
import { keyContext } from '../KeyContext';

function EditChosenBox({shown,close, modalshown}) {
  const clientHeight = shown ?  document.getElementById('tes').clientHeight : ''
  // console.log(clientHeight)
  const {leftMargin} = useContext(keyContext)

  return shown ? (
    <div  className= { modalshown === false ? "modal-backdrop" : '' }
       style={{top:'69px',width:modalshown === false ? '100%' : '',height:modalshown === false ? clientHeight : '',left:modalshown === false ? leftMargin:'',backgroundColor:'rgba(0,0,0,0.5)'}}
     > 
     
     </div>
  )
  : ''
}

export default EditChosenBox